

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button *ngIf="isInspector" [disabled]="!habilitarNuevoSeguimiento" class="btn btn-outline-success" (click)="onAddSeguimiento()"><i class="fa fa-file-o"></i> Nuevo Seguimiento</button>
        </div>
    </nav>

    <div class="animated fadeIn container-fluid">

        <h4 style="display:inline">Seguimientos {{CodigoSolicitud}}</h4>
        <h5 style="display:inline; margin-left: 8px">
            <span>
                <!--***ICONOS***-->
                <img class="estado-icono-big" container="body" src="{{IdTipoSolicitudEx | IconoTipoSolicitudEx}}" ngbTooltip="{{tituloTipoSolicitudEx}}" />
                <img class="estado-icono-big" container="body" src="{{IdEstadoSolicitudEx | IconoEstadoSolicitudEx}}" ngbTooltip="{{EstadoSolicitudExDescripcion}}" />
                <img *ngIf="solicitudExSeguimiento?.IdSubTipoSolicitudEx === tercerPaisConAtestFito || solicitudExSeguimiento?.IdSubTipoSolicitudEx === reExpConAtestFito || solicitudExSeguimiento?.IdSubTipoSolicitudEx === canariasConAtestFito"
                     class="estado-icono-big" src="{{IdSubTipoSolicitudEx | IconoTwTcSubTipoSolicitudEx}}" container="body" ngbTooltip="{{IdSubTipoSolicitudExDescripcion}}" />
                <img class="estado-icono-big" container="body" src="{{IdEstadoCertificadoFitoEx | IconoEstadoCertificadoFitoEx}}" ngbTooltip="{{IdEstadoCertificadoFitoExDescripcion}}" />
                <img *ngIf="solicitudExSeguimiento?.IdResultadoEnvioMuestrasLaboratorioEx" class="estado-icono-big" container="body" src="{{solicitudExSeguimiento.IdResultadoEnvioMuestrasLaboratorioEx | IconoResultadoEnvioMuestraLaboratorio}}" ngbTooltip="{{solicitudExSeguimiento.DescripcionIdResultadoEnvioMuestrasLaboratorioEx}}" />
                <img *ngIf="esClonada" class="estado-icono-big" container="body" src="{{ null | IconoEstadoSolicitudEx}}" ngbTooltip="Clonada" />
                <i *ngIf="esClonada" class="fa fa-clone clone-icono-big" ngbTooltip="Clonada"></i>
            </span>
        </h5>

        <div class="row">
            <div class="col-md-12">
                <div class="card card-accent-success">

                    <div class="card-header-buscador">
                        <i class="fa fa-align-justify"></i> Listado de Seguimientos
                    </div>

                    <div class="card-body-grid">

                        <p-table #tableSearchObservaciones autoLayout="true" [value]="TComentarioInspectorExCollection"
                                 [columns]="colsObservaciones" sortField="Fecha" sortOrder="-1"
                                 styleClass="table table-responsive-sm table-striped table-sm table-0-marginbot"
                                 [ngClass]="displayGridHidden(TComentarioInspectorExCollection)">

                            <ng-template pTemplate="header" let-columns>
                                <tr>
                                    <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                        {{col.header}}
                                        <p-sortIcon *ngIf="col.field!=='Link'" [field]="col.field"></p-sortIcon>
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded" let-rowIndex="rowIndex">
                                <tr>

                                    <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                        <span *ngIf="(col.field!=='Link' && col.field!=='Fecha')">{{rowData[col.field]}}</span>
                                        <span *ngIf="col.field==='Fecha'">{{rowData[col.field] | date:'dd/MM/yyyy HH:mm:ss'}}</span>
                                        <div *ngIf="col.field==='Link'" class="btn-group">

                                            <div *ngIf="checkEditSeguimiento(rowData)">
                                                <button (click)="onEditSeguimiento(rowData)" type="button" title="Editar"
                                                        class="btn btn-sm btn-warning">
                                                    <span class="fa fa-edit"></span>

                                                </button>
                                            </div>

                                            <div *ngIf="!checkEditSeguimiento(rowData)">
                                                <button (click)="onEditSeguimiento(rowData)" type="button" title="Consultar"
                                                        class="btn btn-sm btn-info">
                                                    <span class="fa fa-search"></span>

                                                </button>
                                            </div>

                                            <div *ngIf="checkDeleteSeguimiento(rowData)">
                                                <button (click)="onDeleteSeguimiento(rowData)" type="button" title="Eliminar"
                                                        class="btn btn-sm btn-danger">
                                                    <span class="fa fa-remove"></span>

                                                </button>
                                            </div>
                                        </div>
                                    </td>
                                </tr>

                            </ng-template>
                        </p-table>
                        <div *ngIf="TComentarioInspectorExCollection?.length == 0" class="empty-grid">
                            No hay seguimientos asociados a la solicitud
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- HISTORIAL DE SOLICITUDES DE PCF -->
        <div class="row" *ngIf="mostrarHistorial">
            <div class="col-md-12">
                <div class="card card-accent-success">
                    <a>
                        <div class="card-header-buscador">
                            <i class="fa fa-file-text-o"></i> Historial de Asignación de PCFs
                        </div>
                    </a>
                    <div class="card-body-detalle mt-3">
                        <div class="card-body-grid">
                            <p-table #dt [value]="THistorialReasignacionPcfExCollection" [rows]="10"
                                     responsiveLayout="scroll" class="table table-bordered"
                                     styleClass="table table-responsive-sm table-striped pb-2">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th *ngFor="let col of colsHistorialPcf">{{ col.header }}</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-historial>
                                    <tr>
                                        <td>{{ historial.NombrePuntoInspeccion }}</td>
                                        <td>
                                            <span>{{ obtenerTextoModoReasignacion(historial.ModoReasignacion) }}</span>
                                        </td>
                                        <td>{{ historial.FechaCambioPcf | date: 'dd/MM/yyyy' }}</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>



    </div>


